import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { NbDialogService } from '@nebular/theme';
import { DateTime } from 'luxon';
import { config } from '@config/config';

import { DataComponent } from '@app/utils/data.component';
import { GaugeData } from '@app/shared/gauge/component';
import { ConfirmComponent } from '@app/shared/confirm/component';

import { Notification } from '@app/models/notifications/notifications.model';
import { NotificationService } from '@app/models/notifications/notifications.service';
import { DeviceService } from '@app/models/devices/devices.service';

import { HeaderState } from '@app/header/header.state';
import { trackEvent } from '@app/utils/amplitude.utils';
import { BudgetRanges } from '@app/notifications/notifications-index/constants';

@Component({
    selector: 'app-notifications',
    templateUrl: './template.html',
    styleUrls: ['./style.scss'],
})
export class NotificationsComponent extends DataComponent<Notification> {
    @Input() unreadNotifications: Notification[];
    @Input() archiveNotification: Function;
    @Input() entitlement: string = null;

    @Output() markedRead = new EventEmitter();
    @Output() clearRead = new EventEmitter();
    @Output() hidePopover = new EventEmitter();

    readonly notifTypes = config.notificationTypes;
    readonly notifTypeFormat = config.notificationTypeFormat;
    gaugeData: Record<number, GaugeData> = {};
    notifications: Notification[] = [];
    loading: boolean = true;

    constructor(private notifs: NotificationService, private dialogService: NbDialogService, private router: Router) {
        super();
    }

    onInit() {
        /*
         * this subscription is observing the notification service
         * the notification service calls the notification data from the header component when the header loads
         * this makes the notification data ready before the notification panel is opened
         */
        this.notifs.unreadNotifications.subscribe((unreadNotifications) => {
            this.unreadNotifications = unreadNotifications;
        });
        trackEvent('Notifications Viewed');
    }

    setRead(model: Notification, read: boolean) {
        this.notifs.setRead(model.id, read).subscribe(() => (model.read = read));
        this.markedRead.emit();
    }

    viewAllNotifications() {
        this.hidePopover.emit();
        this.router.navigate(['/notifications']);
    }
}
